export const getLocalDateISOString = (date = new Date()) => {
  const offset = date.getTimezoneOffset() * 60000;
  // Subtract the offset to get the local time represented as UTC
  // e.g. UTC 10:00, Offset 480 (8h). Result: 02:00.
  // Then toISOString() will print 02:00... which is the local time.
  return new Date(date.getTime() - offset).toISOString().split('T')[0];
};

export const getLocalDateTimeString = (date = new Date()) => {
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
};
